<template>
  <strapi-image-component
    v-if="image4Render"
    :image="image4Render"
    :alt="alt"
    :width="image4Render.width"
    :height="image4Render.height"
  />
</template>
<script lang="ts" setup>
import { useStrapiResponsiveImage } from "~/composables";
import { StrapiImage as StrapiImageComponent } from "~/components/strapi";
import { StrapiResponsiveImage } from "~/types/strapi/components";

const props = defineProps<{ image: StrapiResponsiveImage; alt?: string }>();

const { image } = toRefs(props);

const { image4Render } = useStrapiResponsiveImage(image);
</script>
